import React, { useEffect, useState } from 'react';
import LoaderComponent from '../../components/loader/loader.component';
import { MapContainer, TileLayer } from 'react-leaflet';
import { LatLng } from 'leaflet';
import GoogleMapsMapComponent from '../../components/google-maps/google-maps-map.component';
import ErrorMessageComponent from '../../components/error-message/error-message.component';
import queryString from "query-string";
import LeafletMapMarkerWaypointComponent from '../../components/map-marker/leaflet-map-marker-waypoint.component';
import GoogleMapMarkerWaypointComponent from '../../components/map-marker/google-map-marker-waypoint.component';

import ApiService from '../../services/api/api.service';
import { IApiServiceResponse } from '../../services/api/api.service.response';

import ItemWaypointMap from '../../models/ItemWaypointMap';
import ItemWaypoint from '../../models/ItemWaypoint';

import 'leaflet/dist/leaflet.css';

const getLeafletLatLng = (value: string) : LatLng => {
    if (value.includes(',')) {
        const valueArray : string[] = value.split(',');
        return new LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
    }
    else {
        const valueArray : string[] = value.split(';');
        return new LatLng(parseFloat(valueArray[0]), parseFloat(valueArray[1]));
    }
};

const getGoogleLatLng = (value: string) : google.maps.LatLngLiteral => {
    if (value.includes(',')) {
        const valueArray : string[] = value.split(',');
        return {
            lat: parseFloat(valueArray[0]),
            lng: parseFloat(valueArray[1]),
        };
    }
    else {
        const valueArray : string[] = value.split(';');
        return {
            lat: parseFloat(valueArray[0]),
            lng: parseFloat(valueArray[1]),
        };
    }
};

interface IWaypointReportPageProps {};

const WaypointsReportPage = (props: IWaypointReportPageProps) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [token, setToken] = useState<string>();
    const [error, setError] = useState<string>("");
    const [waypointMap, setWaypointMap] = useState<ItemWaypointMap>();

    useEffect(() => {
        let queryParams : queryString.ParsedQuery<string> = queryString.parse(window.location.search);
        setToken(queryParams.Token?.toString() || "");
    }, []);

    useEffect(() => {
        if (token) {
            ApiService.Token({
                Token: token,
            }).then((response: IApiServiceResponse<ItemWaypointMap>) => {
                setWaypointMap(response.Datos);
                setLoading(false);
            }, (error: string) => {
                setError(error);
                setLoading(false);
            });
        }
    }, [token]);

    return (
        <div className='d-flex flex-column h-100 w-100'>
            {
                (waypointMap && !loading && !error) ? (
                    <div className="row m-0 flex-fill overflow-hidden">
                        <div className="col-12 h-100 overflow-hidden px-2">
                            {
                                (waypointMap.TipoMapa === "OSM") ? (
                                    <MapContainer 
                                        center={getLeafletLatLng(waypointMap.WayPoint[0].CoordenadasGPSInicio)} 
                                        zoom={8}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            minHeight: 400,
                                        }}>
                                        <TileLayer
                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                        {
                                            waypointMap.WayPoint.map((waypoint: ItemWaypoint, index: number) => (
                                                <LeafletMapMarkerWaypointComponent 
                                                    key={index}
                                                    startCoordinates={getLeafletLatLng(waypoint.CoordenadasGPSInicio)}
                                                    endCoordinates={getLeafletLatLng(waypoint.CoordenadasGPSFin)}
                                                    iconStartUrl={waypoint.URLIcono}
                                                    iconEndUrl={waypoint.URLIconoFinal}
                                                    waypointStartIconUrl={waypoint.URLIconoWaypoint}
                                                    waypointEndIconUrl={waypoint.URLIconoWaypointFinal}
                                                    titleStart={waypoint.Titulo}
                                                    textStart={waypoint.Texto}
                                                    titleEnd={waypoint.TituloFinal}
                                                    textEnd={waypoint.TextoFinal} />
                                            ))
                                        }
                                    </MapContainer>
                                ) : (waypointMap.TipoMapa === "MAP") ? (
                                    <GoogleMapsMapComponent
                                        zoom={8}
                                        center={getGoogleLatLng(waypointMap.WayPoint[0].CoordenadasGPSInicio)}>
                                        {
                                            waypointMap.WayPoint.map((waypoint: ItemWaypoint, index: number) => (
                                                <GoogleMapMarkerWaypointComponent
                                                    key={index.toString()}
                                                    startCoordinates={getLeafletLatLng(waypoint.CoordenadasGPSInicio)}
                                                    endCoordinates={getLeafletLatLng(waypoint.CoordenadasGPSFin)}
                                                    startIconUrl={waypoint.URLIcono}
                                                    endIconUrl={waypoint.URLIconoFinal}
                                                    titleStart={waypoint.Titulo}
                                                    textStart={waypoint.Texto}
                                                    titleEnd={waypoint.TituloFinal}
                                                    textEnd={waypoint.TextoFinal} />
                                            ))
                                        }
                                    </GoogleMapsMapComponent>
                                ) : (
                                    null
                                )
                            }
                        </div>
                    </div>
                ) : (
                    null
                )
            }
            {
                (!loading && error) ? (
                    <ErrorMessageComponent message={error} />
                ) : (
                    null
                )
            }
            <LoaderComponent loading={loading} />
        </div>
    );
};

export default WaypointsReportPage;
